import { put, takeLatest } from "redux-saga/effects";
import { requestInvoiceTallyDetailsList } from "services/acclgl/reports/invoiceTallyDetails";
import {
    fetchInvoiceTallyDetailsListRequest,
    fetchInvoiceTallyDetailsListSuccess,
    fetchInvoiceTallyDetailsListFailure,
} from "redux/reducers/acclgl/reports/invoiceTallyDetails";

export function* watchInvoiceTallyDetailsSaga() {
  yield takeLatest(fetchInvoiceTallyDetailsListRequest, fetchInvoiceTallyDetailsList);
}

function* fetchInvoiceTallyDetailsList({ payload }) {
  try {
    const response = yield  requestInvoiceTallyDetailsList(payload);
    yield put(fetchInvoiceTallyDetailsListSuccess(response));
  } catch (error) {
    yield put(
        fetchInvoiceTallyDetailsListFailure("Failed to get list of reports")
    );
  }
}
